import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'mobx-react';
import './assets/style/index.scss';
import App from './components/App';
import mainStore from './stores/mainStore';
import CookieStore from "./stores/CookieStore";

import * as serviceWorker from './serviceWorker';

const stores = {
    mainStore,
    AllInputsStore: mainStore.AllInputsStore,
    AllInputsBlocksStore: mainStore.AllInputsBlocksStore,
    CookieStore: mainStore.CookieStore,
}

ReactDOM.render(
    <React.StrictMode>
        <Provider {...stores}>
            <App/>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
